import React from 'react';

export interface FeedbackPanelProps {
  children?: React.ReactNode;
  footer: React.ReactNode;
  logo?: React.ReactNode;
  subtitle: React.ReactNode;
  title: string;
}

export const FeedbackPanel: React.FC<FeedbackPanelProps> = ({ footer, logo, subtitle, title, children }) => (
  <article className="flex flex-col justify-center">
    <div className="sm:mx-auto sm:w-full sm:max-w-md">
      {logo && <div className="flex h-12 justify-center">{logo}</div>}

      <h2 className="mt-6 text-center text-2xl font-semibold leading-9 text-gray-900">{title}</h2>
      <p className="mt-2 text-center text-sm text-gray-600">{subtitle}</p>
    </div>
    {children}
    <footer className="pt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div className="text-center text-sm">{footer}</div>
    </footer>
  </article>
);
